module.exports = __webpack_public_path__ + "img/item1.eed12312.jpg";